import { useParams, Link } from 'react-router-dom';
import './App.css';

const imageMap = {
  'carpet-weaving-1': '/asset/Carpet Weaving/1.jpeg',
  'carpet-weaving-2': '/asset/Carpet Weaving/2.jpeg',
  'carpet-weaving-3': '/asset/Carpet Weaving/3.jpeg',
  'carpet-weaving-4': '/asset/Carpet Weaving/4.jpeg',
  'hand-tufted-1': '/asset/Hand Tufted/1.jpeg',
  'hand-tufted-2': '/asset/Hand Tufted/2.jpeg',
  'hand-tufted-3': '/asset/Hand Tufted/3.jpeg',
  'hand-tufted-4': '/asset/Hand Tufted/4.jpeg',
  'modern-tufted-1': '/asset/HandTufted Modern/1.jpeg',
  'modern-tufted-2': '/asset/HandTufted Modern/2.jpeg',
  'modern-tufted-3': '/asset/HandTufted Modern/3.jpeg',
  'handloom-1': '/asset/Handloom/1.jpeg',
  'handloom-2': '/asset/Handloom/2.jpeg',
  'handloom-3': '/asset/Handloom/3.jpeg',
  'handloom-4': '/asset/Handloom/4.jpeg',
};

function ImageDetail() {
  const { imagePath } = useParams();
  const imageSrc = `${process.env.PUBLIC_URL || ''}${imageMap[imagePath] || '/asset/logo.jpeg'}`;

  return (
    <div className="detail-page">
      <Link className="back-link" to="/">
        ← Back to gallery
      </Link>
      <div className="detail-card">
        <img src={imageSrc} alt="Selected carpet collection" />
      </div>
    </div>
  );
}

export default ImageDetail;
